<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <div>
            <span style="color: #2eabff; width: 30px" >|</span>
            <span>基础信息</span>
          </div>
          <a-col :span="12">
            <a-form-model-item label="物业公司法人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="propertyCorporation">
              <a-input v-model="model.propertyCorporation" placeholder="请输入物业公司法人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="物业单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="propertyName">
              <a-input v-model="model.propertyName" placeholder="请输入物业单位名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <div>
            <span style="color: #2eabff; width: 30px" >|</span>
            <span>添加客户</span>
          </div>
          <a-col :span="12">
            <a-form-model-item label="公司法人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="corporation">
              <a-input v-model="model.corporation" placeholder="请输入公司法人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name" placeholder="请输入单位名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="厂区-区域-楼栋" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="treeData">
              <a-tree-select
                style="width: 100%"
                v-model="model.treeData"
                :tree-data="treeData"
                @treeExpand="handlerTreeExpand"
                tree-checkable
                allow-clear
                :show-checked-strategy="SHOW_PARENT"
                placeholder="请选择厂区-区域-楼栋"
                @change="handlerChange"
                @select="handlerSelect"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="系统账号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalId">
              <a-select
                placeholder="请选择系统账号"
                v-model="model.principalId" :options="sysAccountOptions"
                @change="handleAccoutChange"
                :disabled="isDisabled"
                allowClear></a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalName">
              <a-input v-model="model.principalName" placeholder="请输入负责人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalMobile">
              <a-input v-model="model.principalMobile" placeholder="请输入手机号码"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="principalEmail">
              <a-input v-model="model.principalEmail" placeholder="请输入邮箱"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { defineComponent, ref, watch } from 'vue';
  import { TreeSelect } from 'ant-design-vue';
  const SHOW_PARENT = TreeSelect.SHOW_CHILD /*TreeSelect.SHOW_PARENT*/;


  export default {
    name: 'PreCustomerForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
          status:'Y'
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           propertyCorporation: [
              { required: true, message: '请输入物业公司法人!'},
           ],
           propertyName: [
              { required: true, message: '请输入物业单位名称!'},
           ],
           corporation: [
              { required: true, message: '请输入公司法人!'},
           ],
           name: [
              { required: true, message: '请输入单位名称!'},
           ],
          treeData: [
            { required: true, message: '请选择楼栋'},
          ],
           status: [
              { required: true, message: '请输入是否启用!'},
           ],
           principalId: [
              { required: true, message: '请选择系统账号'},
           ],
          principalAccount: [
            { required: true, message: '请输入系统账号!'},
          ],
          principalName: [
            { required: true, message: '请输入负责人!'},
          ],
          principalEmail: [
            { required: true, message: '请输入邮箱!'},
            {validator: this.validateEmail},
          ],
          principalMobile: [
            { required: true, message: '请输入手机号码!'},
            { validator: this.validateMobile }
          ],
        },
        url: {
          add: "/prevent/customer/add",
          edit: "/prevent/customer/edit",
          tree: "/prevent/customer/treeList",
          queryById: "/prevent.datamaster/precustomer/",
          factoryList:'/sys/epFactory/list',
        },
        SHOW_PARENT,
        factory:[],
        treeData:[],
        sysAccountOptions:[],
        isDisabled:false,
        pageState : 0  // 1: 编辑  2 :成员 3: 详情
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.getRoleByCode()
      this.initTreeList();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
      //  this.edit(this.modelDefault);
      },
      edit (record) {
        let buildIds = []
        if (record.buildIds != null) {
          buildIds = record.buildIds.split(",")
        }
        this.model = {...record, treeData: buildIds};
        this.visible = true;
        this.pageState = this.model.pageState
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
          //  that.confirmLoading = true;
         //   that.$emit('handlerNextPage', this.model) //子组件事件传递给父组件 (PreCustomerForm -> PreCustomerModal -> PreCustomerList)

            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            console.log('111111111 this.model : ',this.model)
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                if(this.pageState === 1) {
                  that.$emit('ok');
                } else {
                  let result = res.result
                  this.model.customerBuildingIds = result.customerBuildingIds  //客户楼栋id
                  this.model.customerId = result.customerId  //客户id

                  that.$emit('handlerNextPage', this.model)
                } 
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      initTreeList(){
        getAction(this.url.tree).then(res=>{
          if(res.success){
            this.treeData = res.result;
            console.log('res.result:',res.result)
          }
        })
      },

      getRoleByCode(){
        getAction('/sys/role/roleByCode',{roleCode:'HeadOfEpidemic'}).then(res=>{
          if(res.success){
            this.getRoleUser(res.result.id)
          }
        })
      },

      getRoleUser(roleId) {
        getAction('/sys/user/userRoleList',{roleId:roleId,pageNo:1,pageSize:99999}).then(res=>{
          if(res.success){
            this.sysAccountOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.realname + " " + item.workNo, value: item.id+""}
              return c;
            })
          }
        })
      },

      handleAccoutChange(value)  {
        getAction('/sys/user/queryById',{id:value}).then(res=>{
          if(res.success){
            let result = res.result
            this.$set(this.model,'employeeNo',result.workNo)
            this.$set(this.model,'principalLandline',result.telephone)
            this.$set(this.model,'principalAccount',result.username)
            this.$set(this.model,'principalName',result.realname)
            this.$set(this.model,'principalEmail',result.email)
            this.$set(this.model,'principalMobile',result.phone)

          }
        })

      },

      handleFactoryChange (value)  {
        this.model.factoryId=`${value}`;
      },

      handlerTreeExpand(expandedKeys) {
        //console.log('handlerTreeExpand expandedKeys : ',expandedKeys)
      },

      handlerChange(value, label, extra) {
      //  console.log('handlerChange : ',value, label, extra)
        this.model.buildIds = value.join(",")
      },

      handlerSelect(value, label, extra) {
       // console.log('handlerSelect  : ',value, label, extra)
      },
      validateMobile(rule, value, callback) {
        if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
          callback();
        } else {
          callback("您的手机号码格式不正确!");
        }
      },
      validateEmail(rule, value, callback){
        if(!value){
          callback();
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            callback();
          }else{
            callback("请输入正确格式的邮箱!");
          }
        }
      },
    }
  }
</script>
